const sliders = [
    {
      element: document.getElementById("price-slider-desktop"),
      minElement: document.querySelector(
        "#desktop-collection-filters #min-price"
      ),
      maxElement: document.querySelector("#desktop-collection-filters #max-price")
    },
    {
      element: document.getElementById("price-slider-mobile"),
      minElement: document.querySelector("#mobile-collection-filters #min-price"),
      maxElement: document.querySelector("#mobile-collection-filters #max-price")
    }
  ];
  
  const initiateSlider = () => {
    // Helper function to format currency
    // function formatNumberCurrency(value) {
    //   return new Intl.NumberFormat("de-DE", {
    //     minimumFractionDigits: 2,
    //     // maximumFractionDigits: 2
    //   }).format(value);
    // }
  
    const onChangePrice = (minPrice, maxPrice) => {
      const newUrl = new URL(window.location.href);
  
      // Add or update the price range filter in the URL
      newUrl.searchParams.set("filter.v.price.gte", minPrice.toString());
      newUrl.searchParams.set("filter.v.price.lte", maxPrice.toString());
  
      // Reset the `page` parameter to 1 (or remove it)
      newUrl.searchParams.delete("page");
      newUrl.searchParams.set("page", "1");
  
      // Remove any existing price range .selected-item
      document
        .querySelectorAll(".selected-item[data-id='price']")
        .forEach(item => item.remove());
  
      // Add the price range as a .selected-item
      const desktopSelectedItemContainer = document.querySelector(
        ".desktop-filter-selected-items"
      );
      const mobileSelectedItemContainer = document.querySelector(
        ".mobile-filter-selected-items"
      );
      const selectedItemHtml = `
        <div class="selected-item" data-id="price" data-value="${minPrice}-${maxPrice}">
          <a href="javascript:void(0);">
            <span class="selected-type">
              <span>Price</span>:
              <strong>${Shopify.formatMoney(
                minPrice * 100
              )} - ${Shopify.formatMoney(maxPrice * 100)}</strong>
            </span>
            <span class="clear"></span>
          </a>
        </div>
      `;
  
      if (desktopSelectedItemContainer) {
        desktopSelectedItemContainer.insertAdjacentHTML(
          "beforeend",
          selectedItemHtml
        );
      }
      if (mobileSelectedItemContainer) {
        mobileSelectedItemContainer.insertAdjacentHTML(
          "beforeend",
          selectedItemHtml
        );
      }
      const cleanUrl = newUrl.toString().replace(/&?view=product-list/, "");
  
      toggleSelectedFiltersVisibility();
  
      // Fetch products with the updated URL
      fetchProducts(cleanUrl);
    };
  
    // Initialize sliders
    sliders.forEach(({ element, minElement, maxElement }) => {
      if (!element) return; // Skip if the element doesn't exist
  
      // Get the current URL
      const currentUrl = new URL(window.location.href);
  
      // Extract min and max price from the URL
      const urlMinPrice = currentUrl.searchParams.get("filter.v.price.gte");
      const urlMaxPrice = currentUrl.searchParams.get("filter.v.price.lte");
      const minPrice = urlMinPrice || nativeFilterVar.min_price;
      const maxPrice = urlMaxPrice || nativeFilterVar.max_price;
      // Initialize the slider
      noUiSlider.create(element, {
        start: [parseFloat(minPrice), parseFloat(maxPrice)],
        connect: true,
        range: {
          min: nativeFilterVar.min_price,
          max: nativeFilterVar.max_price
        },
        step: nativeFilterVar.step,
        pips: {
          mode: "values",
          values: nativeFilterVar.price_range,
          density: 100,
          format: {
            to: value => value.toLocaleString(),
            from: value => Number(value.replace(/,/g, ""))
          }
        }
      });
  
      // Update displayed price values when the slider changes
      element.noUiSlider.on("update", values => {
        if (minElement) minElement.value = Shopify.formatMoney(values[0] * 100, '{{amount}}');
        if (maxElement) maxElement.value = Shopify.formatMoney(values[1] * 100, '{{amount}}');
      });
  
      // Add price range filter to the URL when the slider changes
      element.noUiSlider.on("set", ([min, max], needReload = true) => {
        const minPrice = Math.floor(min); // Get the minimum price
        const maxPrice = Math.floor(max); // Get the maximum price
        // if (needReload) {
          onChangePrice(minPrice, maxPrice);  
        // }
      });
  
      // Set initial values for min and max price displays
      if (minElement) minElement.value = Shopify.formatMoney(minPrice * 100, '{{amount}}');
      if (maxElement) maxElement.value = Shopify.formatMoney(maxPrice * 100, '{{amount}}');
    });
  };
  
  addEventListener("load", () => {
    const desktopCollectionFilter = document.getElementById(
      "desktop-collection-filters"
    );
    if (desktopCollectionFilter) {
      desktopCollectionFilter.addEventListener("submit", function(event) {
        event.preventDefault();
        submitForm();
      });
      desktopCollectionFilter.addEventListener("reset", function() {
        window.location.href = "{{ collection.url }}";
      });
    }
  
    const mobileCollectionFilter = document.getElementById(
      "mobile-collection-filters"
    );
    if (mobileCollectionFilter) {
      mobileCollectionFilter.addEventListener("submit", function(event) {
        event.preventDefault();
        submitForm();
      });
  
      mobileCollectionFilter.addEventListener("reset", function() {
        window.location.href = "{{ collection.url }}";
      });
    }
  });
  
  const submitForm = () => {
    const selectedPrice = document.getElementById("filter-by-price").value;
    const selectedAvailability = document.getElementById("filter-by-availability")
      .value;
    const selectedType = document.getElementById("filter-by-type").value;
    const selectedVendor = document.getElementById("filter-by-vendor").value;
  
    let url = "{{ collection.url }}";
    const params = [];
  
    if (selectedPrice) {
      params.push(`price=${selectedPrice}`);
    }
    if (selectedAvailability) {
      params.push(`availability=${selectedAvailability}`);
    }
    if (selectedType) {
      params.push(`type=${selectedType}`);
    }
    if (selectedVendor) {
      params.push(`vendor=${selectedVendor}`);
    }
  
    if (params.length > 0) {
      url += `?${params.join("&")}`;
    }
  
    window.location.href = url;
  };
  
  
  const calculateProductHeightItem = () => {
    const images = document.querySelectorAll(
      ".product-grid .global-image-wrapper .image"
    );
    let maxHeight = 0;
  
    images.forEach(img => {
      img.onload = function() {
        maxHeight = Math.max(maxHeight, img.clientHeight);
        applyMaxHeight();
      };
  
      // In case the image is already loaded
      if (img.complete) {
        maxHeight = Math.max(maxHeight, img.clientHeight);
      }
    });
  
    function applyMaxHeight() {
      images.forEach(img => {
        img.style.height = maxHeight + "px";
        img.parentElement.parentElement.parentElement.parentElement.parentElement.style.height =
          maxHeight + "px";
      });
    }
  
    // Apply max height in case images were already loaded
    applyMaxHeight();
  }
  document.addEventListener("DOMContentLoaded", function() {
    calculateProductHeightItem()
  });
  
  addEventListener("load", function() {
    const $mobileFilterToggle = $(".mobile-filter-toggle");
    const $mobileFilterContent = $(".mobile-filter-content");
    const $closeFilterButton = $(".close-filter");
  
    // Function to open the mobile filter
    function openMobileFilter() {
      $mobileFilterContent.slideDown(500); // Slide down with 500ms animation
    }
  
    // Function to close the mobile filter
    function closeMobileFilter() {
      $mobileFilterContent.slideUp(500); // Slide up with 500ms animation
    }
  
    // Toggle mobile filter content
    $mobileFilterToggle.on("click", function(event) {
      event.stopPropagation(); // Prevent event from bubbling up
      if ($mobileFilterContent.is(":visible")) {
        closeMobileFilter();
        $(this).removeClass('active')
      } else {
        openMobileFilter();
        $(this).addClass('active')
      }
    });
  
    // Close mobile filter content
    $closeFilterButton.on("click", function(event) {
      event.stopPropagation(); // Prevent event from bubbling up
      closeMobileFilter();
    });
  
    // Close filter when clicking outside the content
    $(document).on("click", function(event) {
      if (
        !$mobileFilterContent.is(event.target) &&
        !$mobileFilterContent.has(event.target).length
      ) {
        closeMobileFilter();
      }
    });
  
    /** for mobile sort by */
    let $dropdown = $("#sortDropdown");
    let $dropdownMobile = $("#sortDropdownMobile");
  
    // Initially hide the dropdown with opacity 0
    $dropdown.css({ display: "none", opacity: 0 });
  
    $("#sortToggle").on("click", function(event) {
      event.stopPropagation();
  
      if ($dropdown.is(":visible")) {
        $dropdown.animate({ opacity: 0 }, 200, function() {
          $(this).hide();
        });
      } else {
        $dropdown.css("display", "block").animate({ opacity: 1 }, 200);
      }
    });
  
    $(document).on("click", function(event) {
      if (!$(event.target).closest("#sortToggle, #sortDropdown").length) {
        $dropdown.animate({ opacity: 0 }, 200, function() {
          $(this).hide();
        });
      }
    });
  
    $dropdownMobile.css({ display: "none", opacity: 0 });
  
    $("#sortToggleMobile").on("click", function(event) {
      event.stopPropagation();
  
      if ($dropdownMobile.is(":visible")) {
        $dropdownMobile.animate({ opacity: 0 }, 200, function() {
          $(this).hide();
        });
        $(this).removeClass('active')
      } else {
        $dropdownMobile.css("display", "block").animate({ opacity: 1 }, 200);
        $(this).addClass('active')
      }
    });
  
    $(document).on("click", function(event) {
      if (
        !$(event.target).closest("#sortToggleMobile, #sortDropdownMobile").length
      ) {
        $dropdownMobile.animate({ opacity: 0 }, 200, function() {
          $(this).hide();
        });
      }
    });
  });
  
  function toggleList(e) {
    const parent = e.currentTarget.parentElement;
    const ul = parent.querySelector("ul");
    if (ul) {
      ul.classList.toggle("show");
    }
    const priceRangeSlider = parent.querySelector(".price-range-slider");
    if (priceRangeSlider) {
      priceRangeSlider.classList.toggle("show");
    }
    e.currentTarget.classList.toggle("up");
  }
  let sortValue = "";
  // Function to fetch products via AJAX
  function fetchProducts(url) {
    // Remove `view=product-list` from the URL for the address bar
    const cleanUrl = url.replaceAll(/([?&])view=product-list(&|$)/g, "$1");
  
    // Update the URL in the address bar
    console.log('cleanUrl', cleanUrl);
    
    history.pushState(null, "", cleanUrl);
  
    url = url.includes('#') ? url.split('#')[0] : url;
    // Ensure the URL includes the `view` parameter
    if (!url.includes("view=product-list")) {
      url += (url.includes("?") ? "&" : "?") + "view=product-list";
    }
  
    fetch(url)
      .then(response => response.text())
      .then(data => {
        // Update the product list and pagination on the page
        const collectionContainer = document.querySelector(
          ".collection-container"
        );
        if (collectionContainer) {
          let tempDiv = document.createElement("div");
          tempDiv.innerHTML = data; // Convert string to HTML
          // Extract content excluding script tags
          let content = tempDiv.querySelectorAll(":not(script)");
          collectionContainer.innerHTML = "";
          content.forEach(el => collectionContainer.appendChild(el));
          // Extract script and parse JSON safely
          let jsonDataElement = collectionContainer.querySelector("#filter-data");
          if (jsonDataElement) {
            try {
              nativeFilterVar = JSON.parse(jsonDataElement.textContent.trim());
            } catch (error) {
              console.error("Error parsing JSON:", error);
            }
          }
          collectionContainer.innerHTML = data;
          new LazyLoad({ elements_selector: ".lazy-new" });
        }
        window.scroll({ top: 0, left: 0, behavior: "smooth" });
  
        assignSelectedFilter()
  
        // Reattach event listeners to the new pagination links
        document.querySelectorAll(".global-pagination a").forEach(function(link) {
          link.addEventListener("click", function(e) {
            e.preventDefault();
            fetchProducts(this.href);
          });
        });
        calculateProductHeightItem();
        /** 
         * TODO: get min and max price of each product
         * and then reload noUiSlider with updated min-max price
        */
        if ($('.product-grid .product-each').length > 1) {
          $('.filter-group-price').each((k, v) => $(v).show())
        } else {
          $('.filter-group-price').each((k, v) => $(v).hide())
        }
      })
      .catch(error => console.error("Error fetching products:", error));
  }
  
  const toggleSelectedFiltersVisibility = function() {
    const desktopSelectedItemContainer = document.querySelector(
      ".desktop-filter-selected-items"
    );
    const selectedFiltersContainer = document.querySelector(".selected-filters");
    if (selectedFiltersContainer && desktopSelectedItemContainer) {
      if (
        desktopSelectedItemContainer &&
        desktopSelectedItemContainer.querySelectorAll(".selected-item").length
      ) {
        desktopSelectedItemContainer.classList.remove('hide')
        selectedFiltersContainer.classList.remove("hide");
      } else {
        selectedFiltersContainer.classList.add("hide");
        desktopSelectedItemContainer.classList.add('hide')
      }
    }
  
    const mobileSelectedItemContainer = document.querySelector(
      ".mobile-filter-selected-items"
    );
    const mobileSelectedFiltersContainer = document.querySelector(".mobile-filter-header");
    if (mobileSelectedFiltersContainer && mobileSelectedItemContainer) {
      // Check if the container has any .selected-item elements
      if (
        mobileSelectedItemContainer &&
        mobileSelectedItemContainer.querySelectorAll(".selected-item").length
      ) {
        mobileSelectedFiltersContainer.classList.remove("hide");
        mobileSelectedItemContainer.classList.remove('hide');
      } else {
        mobileSelectedFiltersContainer.classList.add("hide");
        mobileSelectedItemContainer.classList.add('hide');
      }
    }
  };
  
  const clearAllFilter = () => {
    const newUrl = new URL(window.location.origin + window.location.pathname);
    if (window.location.search.includes("view=")) {
      newUrl.searchParams.set("view", "product-list");
    }
  
    // Reset the `page` parameter to 1
    newUrl.searchParams.set("page", "1");
  
    
    if (sortValue) {
      newUrl.searchParams.set("sort_by", sortValue);
    }
  
    // Remove all .selected-item elements
    document.querySelectorAll(".selected-item").forEach(item => item.remove());
  
    // Remove the .active class from all filter links
    document
      .querySelectorAll(".filter-group a.active")
      .forEach(link => link.classList.remove("active"));
  
    // Fetch products with the updated URL
    fetchProducts(newUrl.toString());
  
    // Hide the .selected-filters container
    toggleSelectedFiltersVisibility();
  };
  
  const initiateSortFunctionality = () => {
    const sortDropdownLinks = document.querySelectorAll("#sortDropdown a, #sortDropdownMobile a");
  
    sortDropdownLinks.forEach(link => {
      link.addEventListener("click", function(e) {
        e.preventDefault();
  
        const newUrl = new URL(window.location.href);
  
        // Preserve the `view` parameter if needed
        const params = new URLSearchParams(window.location.search);
        if (params.has("view")) {
          newUrl.searchParams.set("view", params.get("view"));
        }
  
        const sortValueData = e.currentTarget.getAttribute("data-sort");
        newUrl.searchParams.set("sort_by", sortValueData);
        newUrl.searchParams.set("page", '1');
  
        sortValue = sortValueData;
  
        const desktopSortSpan = document.querySelector('.desktop-sort span');
        if (desktopSortSpan) {
          desktopSortSpan.innerHTML = `Sort By: ${e.currentTarget.innerHTML}`  
        }
        const mobileSortSpan = document.querySelector('.mobile-sort span');
        if (mobileSortSpan) {
          // mobileSortSpan.innerHTML = `Sort By: ${e.currentTarget.innerHTML}`  
        }
        if ($(window).width() < 768) {
          document.querySelector('#sortToggleMobile').click();
        } else {
          document.querySelector('#sortToggle').click();
        }
        fetchProducts(newUrl.toString());
      });
    });
  
    // Preserve the `view` parameter if needed
    const params = new URLSearchParams(window.location.search);
    if (params.has("sort_by")) {
      const sortUrlValue = [...document.querySelectorAll("#sortDropdown a")].find(v => 
        v.getAttribute("data-sort") === params.get("sort_by")
      )?.innerHTML || "";
      sortValue = sortUrlValue
      const desktopSortSpan = document.querySelector('.desktop-sort span');
      if (desktopSortSpan) {
        desktopSortSpan.innerHTML = `Sort By: ${sortValue}`  
      }
      const mobileSortSpan = document.querySelector('.mobile-sort span');
      if (mobileSortSpan) {
        // mobileSortSpan.innerHTML = `Sort By: ${sortValue}`
      }
    }
  };

  const assignSelectedFilter = () => {
    // Reapply the `active` class to filter links based on the current URL
    const currentUrl = new URL(window.location.href);
    document.querySelectorAll(".filter-group a").forEach(function(link) {
      const linkUrl = new URL(link.href);
      const filterKey = linkUrl.searchParams.keys().next().value;
      const filterValue = linkUrl.searchParams.get(filterKey);

      // Check if the filter is active in the current URL
      if (
        filterValue &&
        currentUrl.searchParams.getAll(filterKey).includes(filterValue)
      ) {
        link.classList.add("active");
      } else {
        link.classList.remove("active");
      }
    });
  }
  
  
  addEventListener("load", function() {
    initiateSlider();
  
    initiateSortFunctionality();
  });
  
  /**
   * for ajax pagination & Filter
   */
  document.addEventListener("DOMContentLoaded", function() {
    // Intercept pagination link clicks
    document.querySelectorAll(".global-pagination a").forEach(function(link) {
      link.addEventListener("click", function(e) {
        e.preventDefault(); // Prevent default link behavior
  
        const url = this.href; // Get the pagination URL
        fetchProducts(url); // Fetch products via AJAX
      });
    });
  
    const clearAllBtn = document.querySelectorAll(".clear-all");
    if (clearAllBtn.length) {
      clearAllBtn.forEach((v) => {
        v.addEventListener("click", function(e) {
          clearAllFilter();
        })
      })
    }
  
    // Handle clicks on .filter-group links
    document.querySelectorAll(".filter-group a").forEach(function(link) {
      link.addEventListener("click", function(e) {
        e.preventDefault();
  
        // Prevent default link behavior
  
        // Toggle the `active` class on the clicked link
        this.classList.toggle("active");
  
        // Get the current URL
        const currentUrl = window.location.href;
  
        // Create a new URL object
        const newUrl = new URL(currentUrl);
  
        // Get the filter key, value, and parent label from the clicked link's attributes
        const filterKey = this.getAttribute("data-id");
        const filterValue = this.getAttribute("data-value");
        const filterParentLabel = this.getAttribute("data-parent-label");
  
        // Get the current active filters for this key
        const currentFilters = newUrl.searchParams.getAll(filterKey);
  
        // Toggle the filter value in the URL
        if (this.classList.contains("active")) {
          const selectedItemDesktopContainer = document.querySelector(
            ".desktop-filter-selected-items"
          );
          const selectedItemMobileContainer = document.querySelector(
            ".mobile-filter-selected-items"
          );
  
          // Add the filter value to the URL
          newUrl.searchParams.append(filterKey, filterValue || "");
  
          // Add the selected filter item HTML
          const selectedItemHtml = `
          <div class="selected-item" data-id="${filterKey}" data-value="${filterValue}">
            <a href="${newUrl.toString()}">
              <span class="selected-type">
                <span>${filterParentLabel}</span>:
                <strong>${filterValue}</strong>
              </span>
              <span class="clear"></span>
            </a>
          </div>
          `;
          if (selectedItemDesktopContainer) {
            selectedItemDesktopContainer.insertAdjacentHTML(
              "beforeend",
              selectedItemHtml
            );
          }
          if (selectedItemMobileContainer) {
            selectedItemMobileContainer.insertAdjacentHTML(
              "beforeend",
              selectedItemHtml
            );
          }
        } else {
          // Remove the filter value from the URL
          const updatedFilters = currentFilters.filter(
            value => value !== filterValue
          );
          newUrl.searchParams.delete(filterKey);
          updatedFilters.forEach(value =>
            newUrl.searchParams.append(filterKey, value)
          );
  
          // Remove the selected filter item HTML
          const selectedItem = document.querySelectorAll(
            `.selected-item[data-id="${filterKey}"][data-value="${filterValue}"]`
          );
  
          if (selectedItem.length) {
            for (const item of selectedItem) {
              item.remove();
            }
          }
        }
  
        // Reset the `page` parameter to 1 (or remove it)
        newUrl.searchParams.delete("page"); // Remove the `page` parameter
        newUrl.searchParams.set("page", "1");
  
        // Set `page=1`
  
        // Fetch products with the updated URL
        fetchProducts(newUrl.toString());
        toggleSelectedFiltersVisibility();
      });
    });
  
    // Handle clicks on the "clear" button inside selected filter items
    const handleClearClick = function(e) {
      // Prevent the default behavior of the <a> tag
      e.preventDefault();
  
      // Stop the event from propagating further and prevent other listeners from firing
      e.stopImmediatePropagation();
  
      // Check if the clicked element is the "clear" button
      if (e.target.classList.contains("clear")) {
        // Get the selected filter item
        const selectedItem = e.target.closest(".selected-item");
        const filterKey = selectedItem.getAttribute("data-id");
        const filterValue = selectedItem.getAttribute("data-value");
  
        // Remove the selected filter item HTML from both containers
        const selectedItems = document.querySelectorAll(
          `.selected-item[data-id="${filterKey}"][data-value="${filterValue}"]`
        );
        selectedItems.forEach(item => item.remove());
  
        // Remove the `active` class from the corresponding filter link
        const filterLink = document.querySelector(
          `.filter-group a[data-id="${filterKey}"][data-value="${filterValue}"]`
        );
        if (filterLink) {
          filterLink.classList.remove("active");
        }
  
        // If the cleared filter is the price range, reset the slider
        console.log("filterKey", filterKey);
  
        // Get the current URL
        const currentUrl = window.location.href;
  
        // Create a new URL object
        const newUrl = new URL(currentUrl);
  
        // Remove the filter value from the URL
        const currentFilters = newUrl.searchParams.getAll(filterKey);
        const updatedFilters = currentFilters.filter(
          value => value !== filterValue
        );
        newUrl.searchParams.delete(filterKey); // Remove all existing values for this key
        updatedFilters.forEach(value =>
          newUrl.searchParams.append(filterKey, value)
        );
  
        if (filterKey === "price") {
          sliders.forEach(({ element, minElement, maxElement }) => {
            if (element) {
              // Check if the slider is already initialized
              if (element.noUiSlider) {
                console.log("Resetting slider to default range");
                element.noUiSlider.set([nativeFilterVar.min_price, nativeFilterVar.max_price], false);
              } else {
                console.error("Slider is not initialized");
              }
            }
          });
          newUrl.searchParams.delete("filter.v.price.gte");
          newUrl.searchParams.delete("filter.v.price.lte");
        }
  
        // Reset the `page` parameter to 1 (or remove it)
        newUrl.searchParams.delete("page"); // Remove the `page` parameter
        newUrl.searchParams.set("page", "1");
  
        // Set `page=1`
  
        // Fetch products with the updated URL
        fetchProducts(newUrl.toString());
      }
  
      toggleSelectedFiltersVisibility();
    };
  
    // Attach event listeners to both containers
    const desktopSelectedItemContainer = document.querySelector(
      ".desktop-filter-selected-items"
    );
    if (desktopSelectedItemContainer) {
      desktopSelectedItemContainer.addEventListener("click", handleClearClick);
    }
    const mobileSelectedItemContainer = document.querySelector(
      ".mobile-filter-selected-items"
    );
    if (mobileSelectedItemContainer) {
      mobileSelectedItemContainer.addEventListener("click", handleClearClick);
    }
  
    setTimeout(() => {
      toggleSelectedFiltersVisibility();
      assignSelectedFilter();
    }, 500);
  });
  